import { render } from "./TodayList.vue?vue&type=template&id=6637accd&scoped=true"
import script from "./TodayList.vue?vue&type=script&lang=js"
export * from "./TodayList.vue?vue&type=script&lang=js"

import "./TodayList.vue?vue&type=style&index=0&id=6637accd&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6637accd"]])

export default __exports__